import React from 'react'
import { allRoutes } from '../routes'
import { useSelector, useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'
import { sideBarMenuItems, ISideBarMenuItem } from './SidebarData'
import { TRootState } from 'redux/reducers/rootReducer'
import { SidebarCompanyLogo } from './SidebarCompanyLogo';
import { RightOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import { toggleSidebar } from 'redux/reducers/app_action_reducers/navigationReducer'



function MySidebar()
{
    const navState = useSelector((state: TRootState) => state.app.navigation);
    const dispatch = useDispatch();
    // console.log('activeRouteId', navState.navigation.activeRouteId);

    function onSidebarToggleClick()
    {
        dispatch(toggleSidebar());
    }

    let rootClass = 'aptec-sidebar';
    if (navState.sidebarOpen) {
        rootClass += ' open';
    }

    return (
        <div className={rootClass}>
            <div className="aptec-content">
                <SidebarCompanyLogo sidebarOpen={navState.sidebarOpen} />
                <div className="aptec-sidebar-menu">
                    {
                        sideBarMenuItems.map((sideBarMenuItem: ISideBarMenuItem, index: number) =>
                        {
                            const route = allRoutes.find(route => route.routeId === sideBarMenuItem.linkRouteId);
                            if (route) {
                                const isActive = sideBarMenuItem.activeRouteIds.indexOf(navState.navigation.activeRouteId) !== -1;
                                let className = 'aptec-sidebar-menu-item';
                                if (isActive) className += ' active';

                                let path = route.path;
                                if (sideBarMenuItem.search) path += '?' + sideBarMenuItem.search;

                                return (
                                    <Link to={path} key={index} className={className}>
                                        <div className="aptec-container">
                                            {sideBarMenuItem.renderIcon()}
                                            <p className="aptec-label">
                                                {sideBarMenuItem.label}
                                            </p>
                                        </div>
                                    </Link>
                                )
                            } else {
                                throw new Error(`Could not find sidebarRoute with id ${sideBarMenuItem.linkRouteId}`);
                            }
                        })
                    }
                </div>
                <div className="aptec-sidebar-footer">
                    <Button shape="circle" icon={<RightOutlined />} onClick={onSidebarToggleClick} />
                </div>
            </div>
        </div>
    )
}


export default MySidebar

